import L from "leaflet";

export const createLocationIcon = (color: string, text = "") => {
  const svg = encodeURIComponent(`
    <svg viewBox="0 0 64 72" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 2C19 2 8 14 8 30C8 44 32 70 32 70C32 70 56 44 56 30C56 14 45 2 32 2Z" fill="${color}"/>
    <circle cx="32" cy="28" r="15" fill="white"/>
    <text x="50%" y="34" font-size="18" font-family="Arial" font-weight="bold" text-anchor="middle" fill="${color}">${text}</text>
</svg>
  `);

  return new L.Icon({
    iconUrl: `data:image/svg+xml,${svg}`,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
    shadowSize: [0, 0],
    className: "custom-icon",
  });
};

export const createCarIcon = (color: string) => {
  const svg = encodeURIComponent(`
    <svg width="48" height="90" viewBox="0 0 48 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 82.8C6.5 80.4 6 78 6 55.3C6 37 5.8 34 4.5 34C2.6 34 2.5 32.4 4.4 31.3C5.2 30.8 5.9 27.9 6.3 23.6C6.8 16 8.7 12.7 13.9 9.6C21.7 5.1 30.4 5.9 37 11.8C41 15.4 41.1 15.8 41.7 23C42.1 27.7 42.8 30.8 43.6 31.3C45.4 32.4 45.4 34 43.6 34C42.3 34 42.1 37.7 41.8 56.5C41.4 84.8 42.3 83.4 25.2 83.8C17.1 84 12.7 83.7 11 82.8Z" fill="url(#paint0_radial_1_2)"/>
      <path d="M11 82.8C6.5 80.4 6 78 6 55.3C6 37 5.8 34 4.5 34C2.6 34 2.5 32.4 4.4 31.3C5.2 30.8 5.9 27.9 6.3 23.6C6.8 16 8.7 12.7 13.9 9.6C21.7 5.1 30.4 5.9 37 11.8C41 15.4 41.1 15.8 41.7 23C42.1 27.7 42.8 30.8 43.6 31.3C45.4 32.4 45.4 34 43.6 34C42.3 34 42.1 37.7 41.8 56.5C41.4 84.8 42.3 83.4 25.2 83.8C17.1 84 12.7 83.7 11 82.8Z" fill="${color}"/>
      <path d="M11 82.8C6.5 80.4 6 78 6 55.3C6 37 5.8 34 4.5 34C2.6 34 2.5 32.4 4.4 31.3C5.2 30.8 5.9 27.9 6.3 23.6C6.8 16 8.7 12.7 13.9 9.6C21.7 5.1 30.4 5.9 37 11.8C41 15.4 41.1 15.8 41.7 23C42.1 27.7 42.8 30.8 43.6 31.3C45.4 32.4 45.4 34 43.6 34C42.3 34 42.1 37.7 41.8 56.5C41.4 84.8 42.3 83.4 25.2 83.8C17.1 84 12.7 83.7 11 82.8Z" fill="${color}"/>
      <path d="M38.6361 14.9623C38.6361 13.7623 31.7361 8.36235 31.0361 9.06235C30.7361 9.26235 32.3361 10.9623 34.6361 12.7623C36.8361 14.4623 38.6361 15.4623 38.6361 14.9623Z" fill="#DBDBDB"/>
      <path d="M12 73.4C10.3 69.1 9.5 56 10.9 56C11.5 56 12 57.6 12 59.8C12 61.9 12.5 64.1 13.2 64.8C14.8 66.4 35.2 66.4 36.8 64.8C37.5 64.1 38 61.9 38 59.8C38 57.6 38.5 56 39.1 56C40.5 56 39.7 69.1 38 73.4L37 76H25H13L12 73.4Z" fill="black"/>
      <path d="M38 44.5C38 38.1 37.2 37.4 28.5 36.4L22.8 35.7L23.4 30.1C23.8 27.1 24.2 24.4 24.5 24.2C25.5 23.2 35.7 26.3 37.7 28.2C39.8 30.2 40 31.2 40 40.2C40 46.1 39.6 50 39 50C38.5 50 38 47.5 38 44.5Z" fill="black"/>
      <path d="M10 40C10 31.1 10.2 29.9 12.1 28.1C14.5 25.8 23.9 23.4 26.4 24.3C28.6 25.2 29.6 28 28 29C27.3 29.4 27.1 30.3 27.4 30.9C27.8 31.5 27.6 32 27.1 32C26.5 32 26 32.8 26 33.9C26 35.3 25 35.8 21 36.3C13 37.3 12 38.2 12 44.5C12 47.5 11.6 50 11 50C10.4 50 10 46 10 40Z" fill="black"/>
      <path d="M9 15.2C9 14 15.9 8.6 16.6 9.3C16.9 9.5 15.3 11.2 13 13C10.8 14.7 9 15.7 9 15.2Z" fill="#DBDBDB"/>
      <path d="M9 15.2C9 14 15.9 8.6 16.6 9.3C16.9 9.5 15.3 11.2 13 13C10.8 14.7 9 15.7 9 15.2Z" fill="#DBDBDB"/>
      <path d="M10 80.5C9.3 79.6 9 78.7 9.3 78.4C10 77.6 14 79.8 14 81C14 82.5 11.4 82.2 10 80.5Z" fill="#FF0000"/>
      <path d="M38 80.5C38.7 79.6 39 78.7 38.7 78.4C38 77.6 34 79.8 34 81C34 82.5 36.6 82.2 38 80.5Z" fill="#FF0000"/>
      <defs>
        <radialGradient id="paint0_radial_1_2" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(2099.32 3863.73) scale(2096.3 3857.01)">
          <stop stop-opacity="0.2"/>
          <stop offset="1" stop-opacity="0"/>
        </radialGradient>
      </defs>
    </svg>
  `);

  return new L.Icon({
    iconUrl: `data:image/svg+xml,${svg}`,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
    shadowSize: [0, 0],
    className: "custom-icon",
  });
};
